import axios from 'axios'
import { useValueState } from '../state'

const Workspaces = useValueState('workspaces')
const Identities = useValueState('identities')

const fetchWorkspaceRegister = async (params, opts = {}) => {
  const r = await axios.post(`/api/workspace/register`, params, opts)
  return r.data
}

const fetchWorkspaceDelete = async (params, opts = {}) => {
  const r = await axios.post(`/api/workspace/delete`, params, opts)
  return r.data
}

const fetchWorkspaceSetReadAccess = async (data, opts = {}) => {
  const r = await axios.post(`/api/workspace/setReadAccess`, data, opts)
  return r.data
}

const fetchAddUser = async (data, opts = {}) => {
  const r = await axios.post(`/api/workspace/user/add`, data, opts)
  return r.data
}

const fetchUpdateUser = async (data, opts = {}) => {
  const r = await axios.post(`/api/workspace/user/update`, data, opts)
  return r.data
}

const fetchRemoveUser = async (data, opts) => {
  const r = await axios.post(`/api/workspace/user/remove`, data, opts)
  return r.data
}

export const fetchWorkspaceList = async (opts) => {
  const r = await axios.get(`/api/workspace/list`, opts)
  return r.data
}

export const fetchWorkspaceListAll = async (opts) => {
  const r = await axios.get(`/api/workspace/listAll`, opts)
  return r.data
}

export const fetchWorkspaceListAllIDs = async (opts) => {
  const r = await axios.get(`/api/workspace/listAllIDs`, opts)
  return r.data
}

export const registerWorkspace = async ({ id, name }, opts) => {
  const workspace = await fetchWorkspaceRegister({ id, name }, opts)
  return workspace
}

export const deleteWorkspace = async ({ id }, opts) => {
  await fetchWorkspaceDelete({ id }, opts)
  await loadWorkspaceList(opts)
}

export const changeWorkspace = async ({ id }, opts) => {
  const params = new URLSearchParams(window.location.search)
  let redirect = params.get('redirect')
  if (!redirect) {
    window.location = `/w/${id}`
    return
  }

  // treat redirects as workspace-relative
  let redirectParts = redirect.split('/').filter(Boolean)
  if (redirectParts[0] === 'w' && redirectParts[1]) {
    // remove workspace from redirect
    redirectParts = redirectParts.slice(2)
  }
  window.location = `/w/${id}/${redirectParts.join('/')}`
}

export const addWorkspaceUser = async (data, opts) => {
  await fetchAddUser(data, opts)
  await loadWorkspaceList(opts)
}

export const removeWorkspaceUser = async (data, opts) => {
  await fetchRemoveUser(data, opts)
  await loadWorkspaceList(opts)
}

export const updateWorkspaceUser = async (data, opts) => {
  await fetchUpdateUser(data, opts)
  await loadWorkspaceList(opts)
}

export const loadWorkspaceList = async (opts) => {
  const { workspaces, identities } = await fetchWorkspaceList(opts)
  Workspaces.replaceState(workspaces)
  Identities.replaceState(identities)
  return workspaces
}

export const setReadAccess = async (data, opts) => {
  await fetchWorkspaceSetReadAccess(data, opts)
  await loadWorkspaceList(opts)
}



// WEBPACK FOOTER //
// ../webmango-core/effects/workspace.js